import { competitionServices, vehiclesServices } from '@services';
import { getCleanedUrlParams } from '@utils';
import { QUERY_KEYS } from 'constants/queryKeys';
import { useRouter } from 'next/router';
import { useQuery } from 'react-query';
import { handleCompetitionVehicles, handleEnums } from './utils';

export const COMPETITION_PAGE_SIZE = 50;

export const useCompetitionVehiclesOperations = () => {
  const router = useRouter();
  const pageSize = COMPETITION_PAGE_SIZE;

  const page = router.query?.page || 1;
  const brand = router.query?.brand;
  const model = router.query?.model;

  const { data: enumsData } = useQuery([QUERY_KEYS.GET_ENUMS_KEY], () =>
    vehiclesServices.getVehiclesEnums()
  );

  const enums = handleEnums(enumsData?.data || {});
  const selectedBrand = enums?.brands?.find((item) => item.value === brand);
  const enabled =
    !!(brand && model) &&
    !!selectedBrand?.models?.find((item) => item.value === model);

  const competitionResponse = useQuery(
    [
      QUERY_KEYS.GET_COMPETITION_VEHICLES_KEY,
      {
        model,
        brand,
        page,
        pageSize: parseInt(pageSize, 10) || COMPETITION_PAGE_SIZE,
      },
    ],
    () =>
      competitionServices.getCompetitionVehicles(
        getCleanedUrlParams({
          q: `${brand} ${model}`.trim().toLowerCase() || undefined,
        })
      ),
    { enabled }
  );

  const vehicles = handleCompetitionVehicles(
    competitionResponse?.data?.vehicles || []
  );

  return {
    total: vehicles?.length,
    loading: competitionResponse?.isLoading,
    enums,
    vehicles,
    page,
    pageSize: parseInt(pageSize, 10) || COMPETITION_PAGE_SIZE,
    brand,
    model,
    getCompetitionVehicles: competitionResponse?.refetch,
  };
};
